var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBrand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 102,
    viewBox: "0 0 291 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    r: 51,
    fill: "#FF5600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 68.9999C209.111 68.6314 206.833 62.3333 206.5 58.9999H219.5C219.5 59.6666 219.7 61.1 220.5 61.5C221.5 62 222 62 223.5 62C225 62 226.5 61.5 226.5 59.5C226.5 57.5 223.5 56.5 222.5 56C221.5 55.5001 217.002 54.5004 212.503 53.5005L212.5 53.4999C208.9 52.6999 207.667 49.1666 207.5 47.4999C207.152 45.4597 207.179 44.3724 207.5 42.5C208.167 40 211.5 34.5 223.5 34.5C235.1 34.5 238.167 41 238 44H226C226 43.2 225.333 42.3333 225 41.9999C224.167 41.6666 222.2 41.1999 221 41.9999C219.5 42.9999 219.5 44.4999 221 45.4999C222.5 46.4999 225 47 228 48C231 49 236 50.9999 238 53.4999C239.6 55.4999 239.333 58.6666 239 59.9999C237.9 65.4996 232.755 68.5957 227.5 68.9999C226.074 69.2595 221.551 69.349 215.5 68.9999Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242 69V35H268V43.5H255.5V47.5H267.5V56H255.5V60H269V69H242Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282 49.6C286.197 49.6 289.6 46.1974 289.6 42C289.6 37.8026 286.197 34.4 282 34.4C277.803 34.4 274.4 37.8026 274.4 42C274.4 46.1974 277.803 49.6 282 49.6ZM282 51C286.971 51 291 46.9706 291 42C291 37.0294 286.971 33 282 33C277.029 33 273 37.0294 273 42C273 46.9706 277.029 51 282 51Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.8 37.8H283.586L283.67 37.8209C284.078 37.923 284.673 38.1602 285.184 38.5633C285.698 38.9698 286.2 39.6102 286.2 40.5C286.2 41.4236 285.573 42.1448 285.01 42.6132C284.689 42.8804 284.337 43.1087 284.007 43.2914L286.093 47H284.316L282.612 43.7H280.2V47H278.8V37.8ZM280.2 42.3H282.859C283.641 42.1557 284.8 41.3125 284.8 40.5C284.8 40.1899 284.635 39.9136 284.316 39.6618C284.023 39.4307 283.664 39.2753 283.407 39.2H280.2V42.3Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 69V35H120.5V60H133.5V69H107.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137 69V35H163V43.5H150.5V47.5H162.5V56H150.5V60H164V69H137Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.5 69H166.5L178 35H186.5V41.5L182.5 55.5H186.5V63.5H181.5L179.5 69Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 69H206.5L195 35H186.5V41.5L190.5 55.5H186.5V63.5H191.5L193.5 69Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69H57L44 52.5L57 35H41L36 41V62.5L41 69Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69H16L29 52.5L16 35H32L37 41V62.5L32 69Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62 69V35H76.5V60H89.5V69H62Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrand);
export default __webpack_public_path__ + "static/media/logo-brand.62168645c9fa7134c4edce16a6c81dfc.svg";
export { ForwardRef as ReactComponent };